export default "__VITE_ASSET__99cbe49c__"